import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import { LanguageProvider } from "./contexts/LanguageContext";

// Router wrapper to handle auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (hash) for session_id - this handles the OAuth callback
  // The format is: /auth/callback#session_id=xxx
  // This check happens synchronously during render to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    // Pass to Home which will show AuthCallback
    return <Home />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<Home />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
